document.addEventListener('click', function (e) {
    if (e.target.closest('.js--control-video')) {
        videoController(e, e.target);
    }

    if (e.target.closest('.js--control-youtube')) {
        youtubeFrameLoader(e, e.target);
    }
}, false);

function videoController(e, btn) {
    e.preventDefault();

    var video = btn.nextElementSibling;

    if (!video) return;

    function togglePlayPause() {
        if (video.paused) {
            video.play();
            btn.classList.add('playing');
            btn.setAttribute('aria-label', btn.getAttribute('data-pause-label'));
        } else {
            video.pause();
            btn.classList.remove('playing');
            btn.setAttribute('aria-label', btn.getAttribute('data-play-label'));
        }
    }

    function resetButton() {
        btn.classList.remove('playing');
        btn.setAttribute('aria-label', btn.getAttribute('data-play-label'));
    }

    // Initial button click
    togglePlayPause();

    // Avoid stacking listeners if this function is called repeatedly
    video.removeEventListener('click', togglePlayPause);
    video.removeEventListener('ended', resetButton);

    video.addEventListener('click', togglePlayPause);
    video.addEventListener('ended', resetButton);
}

function youtubeFrameLoader(e) {
    e.preventDefault();

    var container = e.target.parentNode,
        iframe = container.querySelector('.js--youtube__iframe'),
        wrapper = iframe.parentNode,
        figure = container.querySelector('.js--youtube__poster'),
        src = iframe.getAttribute('data-src');

    e.target.classList.add('-loaded');
    container.classList.add('-loaded');
    figure.classList.add('-hidden');
    wrapper.classList.add('-visible');

    if (iframe.getAttribute('src') === '') {
         iframe.setAttribute('src', src);
    }
}